export function LOGIN_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function LOGIN_SUCCESS(state, payload) {
  localStorage.setItem(
    "user",
    JSON.stringify(payload.results.data.data.internal_user)
  );
  localStorage.setItem("id_token", payload.results.data.data.access_token);
  localStorage.setItem(
    "refresh_token",
    payload.results.data.data.refresh_token
  );
  state;
  state.currentUser = payload.results.data.data.internal_user;
  state.isLoading = false;
}
export function LOGIN_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}

export function LOGOUT_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function LOGOUT_SUCCESS(state) {
  state;
  state.currentUser = null;
  state.isLoading = false;
}
export function LOGOUT_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
